<template>
    <div style="margin: 20px 0;">
        <el-upload class="upload-demo" accept="https://oss.saas.tling.vip/" :file-list="fileList.name" :before-upload="beforeUpload" action="/">
            <el-button type="primary" size="mini">上传</el-button>
        </el-upload>
        <div style="margin: 20px 0;" v-if="uploadFileUrl">{{ filename }}</div>
        <div style="margin: 20px 0;" v-else-if="posterDetail.url">{{ posterDetail.url }}</div>

        <el-image v-if="uploadFileUrl" :src="uploadFileUrl"></el-image>
        <el-image v-else-if="posterDetail.url" :src="`${domainUrl}${posterDetail.url}`" alt="" style="width: 300px;height: 300px;"></el-image>
        
        <div class="fengqi" style="display: flex;flex-direction: column;align-items: center;justify-content: center; position: fixed;top: -5000px;z-index: -1;" ref="fengqiRef">
            <img :src="uploadFileUrl" ref="fengqiPoster" alt="">
            <div id="fengqi_blank_box" style="width: 750px;height: 200px;background: #FFFFFF;"></div>
        </div>
        
    </div>
    
    
</template>

<script>
import request from "@/api/request";
import html2canvas from "html2canvas";
export default {
    props: ['id', 'fileList', 'type', 'posterDetail'],
    data() {
        return {
            filename: '',
            uploadFile: {},
            uploadFileUrl: '',
            posterYBList: [],
            imageURL: '',
            posterBase: 'https://oss.saas.uat.finadv.cn/',
            uploadPosterUrl: '',
            domainUrl: '',
            uploadImageUrl: ''
        };
    },
    mounted() {
        //console.log(this.posterDetail.url)
        let domainUrl = ''
        if(location.href.includes("finadv")){
            domainUrl = 'https://oss.saas.uat.finadv.cn/'
        } else {
            domainUrl = 'https://oss.saas.tling.vip/'
        }
        this.domainUrl = domainUrl
    },
    methods: {
        //上传文件
        beforeUpload(file){
            //console.log('file', file)
            let that = this
            this.filename = file.name
            this.uploadFile = file
            let reader = new FileReader()
            reader.onload = function (event) {
                let txt = event.target.result
                let img = document.createElement("img")
                img.src = txt
                img.onload = function () {
                    //console.log(img.width, img.height)
                    let imgWidth = img.width
                    let imgHeight = img.height
                    if(imgHeight > 2000) {
                        document.getElementById('fengqi_blank_box').style.height = '360px'
                    }
                    that.getBase64(file).then((res) => {
                        //console.log(res)
                        let base64Str = res.split(',')[1]
                        that.uploadImageUrl = base64Str
                        if(!file.type) {
                            that.$message.warning('暂不支持此文件格式')
                            return
                        }
                        let type = file.name.split(".").pop()
                        that.uploadFileUrl = `data:image/${type};base64,${base64Str}`
                        //console.log('beforeUpload', base64Str)

                        if(that.type === 4) {
                            that.$refs.fengqiPoster.onload = function() {
                                html2canvas(that.$refs.fengqiRef, {
                                    useCORS: true,
                                    scale: 3,
                                    removeContainer: true,
                                    width: imgWidth
                                }).then(canvas => {
                                    let url = canvas.toDataURL()
                                    //console.log(url)
                                    let fengqiStr = url.split(',')[1]
                                    that.handleUploadFile(fengqiStr, type, file.name)
                                })
                            }

                        } else {
                            that.handleUploadFile(base64Str, type, file.name)
                        }
                    })
                }
            }
            reader.readAsDataURL(file)
            
        },
        handleUploadFile(base64Str, type, name){
            //上传海报图片
            //console.log('base64Str',base64Str)
            
            request.saas
                .post("product/upload_product_poster_file", {
                    content: base64Str,
                    suffix: type
                })
                .then(resp => {
                    //this.uploadFileUrl = resp.data.url
                    this.uploadProductAppendix(resp.data.url, name)
                })
        },
        uploadProductAppendix(url, name){
            //上传产品海报
            if(!this.type){
                this.$message.warning('请选择海报类型')
                return
            }
            request.saas
                .post("product/upload_product_poster", {
                    url: url,
                    type: this.type,//this.productPoster.type,
                    product_main_id: String(this.id)
                })
                .then(() => {
                    this.$message.success('上传海报成功')
                    let file = {
                        type: this.type,
                        name: name,
                        url: this.uploadFileUrl
                    }
                    this.$emit('handleChangePosterUpload', file)
                })
        },
        getBase64(file){
            return new Promise(function(resolve, reject) {
                let reader = new FileReader();
                let imgResult = null;
                reader.readAsDataURL(file);
                reader.onload = function() {
                    imgResult = reader.result;
                };
                reader.onerror = function(error) {
                    reject(error);
                };
                reader.onloadend = function() {
                    resolve(imgResult);
                };
            });
        },
    }
}
</script>
<style scoped>
>>> .avatar-uploader .el-upload{
    border: 0;
}
>>> .upload-demo{
    display: flex;
    flex-direction: row;
    align-items: center;
}
>>> .upload-demo .el-upload--text{
    margin-right: 20px;
}
.poster-box{
    position: relative;
    background: red;
}
.poster-img{
    
}
.blank-box{
    position: fixed;
}
.blank_niubao{
    left: 32px;
    bottom: 40px;
    width: 148px;
}
.blank_qixin{
    right: 117px;
    bottom: 532px;
    width: 472px;
    height: 472px;
}
.blank_yunfu{
    right: 25px;
    bottom: 25px;
    width: 190px;
    height: 190px;
}
.blank_fengqi{
    
}
</style>
